// Pure, no closures — kept in its own module (rather than inline in LegalCases.tsx)
// so it's directly unit-testable without pulling in LegalCases.tsx's render-tree
// import chain. A caseRow can arrive from the API with no `cases` key (e.g. a
// party with zero cases), which must not throw (regression for AICA-APP-8M).
export const flattenAndLimitCases = (casesData: any[] | null | undefined, isPDFReport: boolean) => {
    return (casesData || []).flatMap((caseRow) =>
        (isPDFReport ? (caseRow.cases ?? []).slice(0, 10) : caseRow.cases ?? []).map((singleCase) => ({
            ...singleCase,
            groupName: caseRow.name,
            groupDesignation: caseRow.designation,
        })),
    );
};
